export default [
    'credit',
    'annuity',
    'interestfree',
    'interestfreepartpayment',
    'directinvoice',
    'invoice',
];
